


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierInbound } from '@/store/models/IDossierInbound';
import ICustomer from '@/store/models/ICustomer';

@Component({ components: { Snackbar } })
export default class DossierInbounds extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;
  @Prop({ type: Boolean, required: true }) ShowCustomer!: boolean;
  @Prop({ type: Array, required: true }) CustomerList!: ICustomer[];

  dossierApi = new DossierApi();
  groupedGoods: any[] = [];
  expanded: any[] = [];
  loadingGoods = false;

  goodsHeaders = [ { text: 'Code', value: 'code' }, { text: 'Customer', value: 'customerName' }, { text: 'Company Source', value: 'companySourceName' }, { text: 'Company Destination', value: 'companyDestinationName' }, { text: 'Date In', value: 'dateIn' }, { text: 'Total Cases', value: 'totalCases' }, { text: 'Total Goods', value: 'totalGoods' } ];
  goodsDetailHeaders = [ { text: 'Good', value: 'goodName' }, { text: 'Pallet Type', value: 'palletType' }, { text: 'Pallets', value: 'palletsAmount' }, { text: 'Cases/Pallet', value: 'casesPerPallet' }, { text: 'Total Cases', value: 'totalCases' }, { text: 'Goods/Case', value: 'goodsPerCase' }, { text: 'Total Goods', value: 'totalGoods' }, { text: 'Best Before', value: 'bestBeforeDate' } ];

  async mounted() {
      await this.loadGoods();
  }

  async loadGoods() {
      if (!this.inboundCode) return;
      this.loadingGoods = true;

      try {
          const data: IDossierInbound[] = await this.dossierApi.DossierReadInbounds(this.inboundCode);
          if (this.ShowCustomer === false) {
              data.forEach((i) => {
                  let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                  if (indexCustomer !== -1) {
                      if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                          i.Customer = "";
                      }
                  } else {
                      i.Customer = "";
                  }
              });
          }
          this.groupedGoods = Object.values(
              data.reduce((acc: any, curr: any) => {
                  if (!acc[curr.id]) {
                      acc[curr.id] = {
                          id: curr.id,
                          code: curr.code,
                          customerName: curr.Customer,
                          companySourceName: curr.CompanySource,
                          companyDestinationName: curr.CompanyDestination,
                          dateIn: curr.dateIn,
                          status: curr.statusName,
                          totalCases: 0,
                          totalGoods: 0,
                          details: []
                      };
                  }
                  acc[curr.id].details.push({
                      goodName: curr.goodName,
                      palletType: curr.palletName,
                      palletsAmount: curr.palletsAmount,
                      casesPerPallet: curr.casesPerPallet,
                      totalCases: curr.totalCases,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods,
                      bestBeforeDate: curr.bestBeforeDate
                  });
                  acc[curr.id].totalCases += curr.totalCases || 0;
                  acc[curr.id].totalGoods += curr.totalGoods || 0;
                  return acc;
              }, {})
          );
      } catch (err) {
          console.error(err);
      } finally {
          this.loadingGoods = false;
      }
  }

  formatDate(dateStr: string) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString();
  }
}
